import { Flavor } from '../store/flavor/api/interface';

export const fillFlavorState = (state: Flavor) => {
  const reqBody = {
    id: state.id ?? '',
    labelEn: state?.labelEn ?? '',
    labelAr: state?.labelAr ?? '',
    code: state?.code ?? '',
    subLabelEn: state?.subLabelEn ?? '',
    subLabelAr: state?.subLabelAr ?? '',
    descriptionEn: state?.descriptionEn ?? '',
    descriptionAr: state?.descriptionAr ?? '',
    previewUrl: state?.previewUrl ?? '',
    position: state?.position ?? '',
    pricePerKg: state?.pricePerKg ?? '',
    // isNew: state?.isNew,
    activeState: state?.activeState,
    imageItems: state?.shapeImages?.map((item) => {
      return {
        shapeId: item?.shapeId ?? '',
        // sliced: item?.sliced ?? '',
        top: item?.top ?? '',
        front: item?.front ?? '',
      };
    }),
  };

  return reqBody;
};
